import { apiClient } from "./ApiClient";

export default class EventApiClient {
    registerScriptError(fileName: string, message: string, stack: string, quoteId: string) {
        return apiClient.instance.request({
            url: '/events/script-error',
            data: {
                fileName,
                message,
                stack,
                quoteId
            }
        });
    }
}